<template>
  <div>
    <aside class="main-sidebar sidebar-dark-success">
      <!-- Brand Logo -->
      <router-link
        to="/"
        class="brand-link navbar-success text-center mb-5"
      >
        <img
          src="/assets/img/logo.png"
          alt="GTL Logo"
          class="brand-image bg-light"
          style="border-radius: 100px; width: 60px; height: 60px; padding: 10px"
        />
      </router-link>

      <!-- Sidebar -->
      <div class="sidebar">
        <!-- <div class="user-panel mt-3 pb-3 mb-3 d-flex">
          <div class="image">
            <img
              v-lazy="'/assets/img/user.png'"
              style="width: 34px; height: 34px; object-fit: cover"
              class="img-circle elevation-2"
              alt="User Image"
            />
          </div>
          <div class="info">
            <a
              data-toggle="collapse"
              href="#collapseExample"
              class=""
              aria-expanded="true"
            >
              <span class="profile-name"
                >{{
                  "Administrator".length > 15
                    ? "Administrator".substring(0, 15) + "..."
                    : "Administrator"
                }}
                &nbsp;</span
              >
              <i class="right fa fa-angle-down" />
            </a>
            <div
              class="collapse in"
              id="collapseExample"
              aria-expanded="true"
              style=""
            >
              <ul class="profile-nav mb-0" style="margin-top: 15px">
                <li>
                  <router-link to="/logout">Logout</router-link>
                </li>
              </ul>
            </div>
          </div>
        </div> -->

        <!-- Sidebar Menu -->
        <nav class="mt-2">
          <ul
            class="nav nav-pills nav-sidebar flex-column nav-child-indent"
            data-widget="treeview"
            role="menu"
            data-accordion="false"
          >
            <li class="nav-item">
              <router-link to="/dashboard" class="nav-link" id="videos">
                <i class="nav-icon fa fa-play"></i>
                <p>Training Videos</p>
              </router-link>
            </li>
            <li class="nav-item" >
              <router-link
                to="/dashboard/forum"
                class="nav-link"
                id="forum"
              >
                <i class="nav-icon fa fa-comments"></i>
                <p>Discussion Forum</p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/dashboard/transcript" class="nav-link" id="transcript">
                <i class="nav-icon fa fa-file"></i>
                <p>Transcript</p>
              </router-link>
            </li>
          </ul>
        </nav>
        <!-- /.sidebar-menu -->
      </div>
      <!-- /.sidebar -->
    </aside>
    <div id="sidebar-overlay" @click="hideMenu"></div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  computed: {
    name: function () {
      return (this.$store.state.userInfo || {}).company_name;
    },
  },
  methods: {
   
    hideMenu() {
      window.$(".sidebar-mini").removeClass("sidebar-open");
      window.$(".sidebar-mini").addClass("sidebar-closed sidebar-collapse");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.profile-nav > li {
  position: relative;
  display: block;
}
.profile-name {
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
